<script>
	import PageShell from '$lib/components/page-shell/PageShell.svelte';
	export let data;
</script>

<PageShell
	{data}
	routeKey="create-account"
	showSkeleton
/>
